import React from 'react';
import { Button } from './ui/Button';
interface HeroProps {
  onJoinClick?: () => void;
}
export function Hero({
  onJoinClick
}: HeroProps) {
  return <div className="relative bg-gray-400 min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-355">
      {/* Optimized Background Image - using img tag for better performance */}
      <img src="https://cdn.magicpatterns.com/uploads/4H7vMpv3GeDGEYCVvASyPc/Hold_my_van_hero.jpg" alt="Caravan storage facility" className="absolute inset-0 w-full h-full object-cover z-0" loading="eager" fetchPriority="high" width="1920" height="1080" data-id="element-356" />
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 via-gray-900/60 to-gray-900/70 z-0" data-id="element-357" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-358">
        <div className="inline-block bg-[#175445] text-[#fbf7dd] px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-6 shadow-lg" data-id="element-359">
          Coming Soon to Perth
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold text-white leading-[1.1] md:leading-relaxed mb-6 drop-shadow-lg" data-id="element-360">
          A safer home for your caravan <br className="hidden md:block" data-id="element-361" />
          or boat - close to Perth
        </h1>

        <p className="text-lg md:text-xl text-gray-100 max-w-3xl mx-auto mb-10 font-medium drop-shadow-md leading-normal md:leading-relaxed" data-id="element-362">
          Storing your caravan in Perth is now easier with Hold My Van. Located
          within 35 km of the Perth CBD, we offer a simple, secure alternative
          to parking your caravan, boat or motorhome on your driveway or verge.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-363">
          <Button variant="secondary" size="lg" className="text-lg px-10 py-6 shadow-xl hover:scale-105 transform transition-transform" onClick={onJoinClick} data-id="element-364">
            Join The Priority List
          </Button>
        </div>
        <p className="mt-4 text-sm text-gray-200 drop-shadow leading-normal md:leading-relaxed" data-id="element-365">
          Sign up for priority access and lock in early bird pricing before we
          open to the broader public
        </p>
      </div>
    </div>;
}